import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsCardContainer } from '@hashicorp/design-system-components/components';
import { DetailSection, DetailCard, Typography } from 'core/components';
import { boxPadding } from 'core/modifiers';
import LocationLink from 'hcp/components/location-link';
import CreateClusterButton from 'hcp/components/create-cluster-button';

/**
 *
 * `PageHvnsCardsAssociatedClusters` this component renders the clusters associated with an HVN.
 *
 *
 * ```
 * <Page::Hvns::Cards::AssociatedClusters
 *   @model={{@model}}
 * />
 * ```
 *
 * @class PageHvnsCardsAssociatedClusters
 *
 */
export default class PageHvnsCardsAssociatedClusters extends Component {
  /**
   * `model` is an HVN Object
   * @argument model
   * @type {Object}
   */
  <template>
    <HdsCardContainer
      data-test-hvns-cards-associated-clusters
      class="cards-associated-clusters"
      @overflow="visible"
      @level="mid"
      @hasBorder={{true}}
    >
      <div {{boxPadding "lg lg lg lg"}}>
        <DetailSection
          @title={{t "components.page.hvns.cards.associated-clusters.title"}}
          as |DS|
        >
          <div {{boxPadding "lg 0 0 0"}}>
            {{#each @model.dependencies as |link|}}
              <DetailCard as |DC|>
                <DC.Header>
                  <Typography @variant="h3">
                    <LocationLink @link={{link}} />
                  </Typography>
                </DC.Header>
              </DetailCard>
            {{else}}
              <DS.ZeroState>
                {{t
                  "components.page.hvns.cards.associated-clusters.zero-state.message"
                }}
              </DS.ZeroState>
            {{/each}}
          </div>
          <CreateClusterButton @model={{@model}} data-test-create-button />
        </DetailSection>
      </div>
    </HdsCardContainer>
  </template>
}
